<template>
    <div>
        <a
            :title="$t('certificate.print')"
            class="btn btn-primary mt-3 mb-1 text-white btn-lg d-print-none"
            @click="download"
        >
            <i class="mdi mdi-cloud-print"></i> {{ $t('certificate.print') }}
        </a>
        <a
            v-if="action === 'print'"
            :title="$t('common.back')"
            class="btn btn-primary mt-3 mb-1 text-white btn-lg d-print-none"
            @click="back"
        >
            <i class="mdi mdi-back"></i> {{ $t('common.back') }}
        </a>
    </div>
</template>

<script>

export default {
    name: 'CertificateToolbar',
    props: {
        id: String,
        action: String,
        certificate: {
            type: Object,
            required: true,
        },
    },
    mounted() {
        if (this.action === 'print') {
            window.print();
        }
    },
    methods: {
        download() {
            if (this.action === 'print') {
                window.print();
            } else {
                window.location.href = `${window.location.href}?action=print`;
            }
        },
        back() {
            window.history.back();
        },
    },
};
</script>
